import typia from "typia";
export interface IValidateError {
    name: string;
    value?: string | string[];
    expected?: string;
}
;
export const isValidateErrors = (input: any): input is IValidateError[] => {
    const $io0 = (input: any): boolean => "string" === typeof input.name && (null !== input.value && (undefined === input.value || "string" === typeof input.value || Array.isArray(input.value) && input.value.every((elem: any) => "string" === typeof elem))) && (undefined === input.expected || "string" === typeof input.expected);
    return Array.isArray(input) && input.every((elem: any) => "object" === typeof elem && null !== elem && $io0(elem));
};
